<template>
  <div class="mb-1 newsletter-registration-consent" v-if="config.newsletter_enabled">
    <div class="form-check">
      <input id="user.newsletter" type="checkbox" class="form-check-input" :checked="!user.newsletter" @change="updateValue">
      <label class="form-check-label" for="user.newsletter">
        {{ translations['I do not want to subscribe to newsletter'] }}
      </label>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      translations: state => state.translations,
      user: state => state.user,
      config: state => state.config,
    }),
  },
  methods: {
    updateValue (event) {
      this.$store.commit('SET_USER_NEWSLETTER', !event.target.checked);
    },
  },
  mounted: function() {
    this.$store.commit('SET_USER_NEWSLETTER', true);
  },
};
</script>